module.exports = __webpack_public_path__ + "img/bannerBecas.91f134b4.png";